'use strict';
import classNames from 'classnames';
import isNumber from 'lodash/isNumber';
import memoize from 'lodash/memoize';
import moment from 'moment';
import * as T from 'prop-types';
import React, {Component} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import IonSpinner from '../../../_libs/reactionic/src/components/ionSpinner';
import {DATE_HEADER, DateHeader, TODAY} from '../../../components/lists/DateHeader';
import * as FlipMoveConfig from '../../../config/style/FlipMoveListConfig';
import {StatusOverlayComponent} from '../../../core-components/loading-icon/components/StatusOverlayComponent';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {ViewMode} from '../../../core-utilities/enums/ViewMode';
import {getMessagesFromProps, I18nComponent} from '../../../core-utilities/react-i18n';
import {UserPin} from '../UserPin';


export const formatDate = memoize(date => isNumber(date) ? moment(date).format('MMMM YYYY') : date);

export class BaseUserPinListComponent extends Component {
  static propTypes = {
    userId: T.string.isRequired,
    onLoadMore: T.func.isRequired,
    hasMore: T.bool,
    onClickItem: T.func.isRequired,
    onItemContextMenu: T.func.isRequired,
    showNoDataIcon: T.bool,
    canScroll: T.bool,

    wrapperClassName: T.string,
    overlayClassName: T.string,
    placeholderTitle: T.string,
    thisMonthLabel: T.string,
    unscheduledMonthLabel: T.string,
    loadMoreLabel: T.string,
  };

  static scrollStyle = {overflowX: 'hidden', overflowY: 'scroll'};
  static defaultStyle = {};

  constructor(props) {
    super(props);

    this.renderItem = this.renderItem.bind(this);
  }

  render() {
    return (
      <div className={this.props.wrapperClassName}>
        <StatusOverlayComponent
          overlayClassName={this.props.overlayClassName}
          mode={this.props.mode}
          showNoDataIcon={this.props.showNoDataIcon}
          noDataLabel={this.props.placeholderTitle}
        />
        <div
          className={classNames({
            'activity-feed-scroll-panel': this.props.canScroll,
          })}
          style={this.props.canScroll ? UserPinListComponent.scrollStyle : UserPinListComponent.defaultStyle}
        >
          <div>
            <ReactCSSTransitionGroup
              transitionName={FlipMoveConfig.transitionName}
              transitionAppear={FlipMoveConfig.transitionAppear}
              transitionAppearTimeout={FlipMoveConfig.transitionAppearTimeout}
              transitionEnterTimeout={FlipMoveConfig.transitionEnterTimeout}
              transitionLeaveTimeout={FlipMoveConfig.transitionLeaveTimeout}
              className="list"
            >
              {this.props.list ? this.props.list.map(this.renderItem) : null}
            </ReactCSSTransitionGroup>
            {this.renderLoadMoreButton()}
          </div>
        </div>
      </div>
    );
  }

  renderItem(model) {
    if (model.type === DATE_HEADER) {
      let label;
      if (model.date === TODAY) {
        label = this.props.thisMonthLabel;
      } else if (model.date === null) {
        label = this.props.unscheduledMonthLabel;
      } else {
        label = model.date;
      }
      return (
        <DateHeader
          key={getId(model)}
          date={label}
          formatDate={formatDate}
        />
      );
    } else {
      return (
        <UserPin
          key={getId(model)}
          className={this.props.itemClassName}
          itemId={getId(model)}
          userId={this.props.userId}
          model={model}
          onClick={this.props.onClickItem}
          onContextMenu={this.props.onItemContextMenu}

          {...getMessagesFromProps(this.props, UserPin.messageProps)}
        />
      );
    }
  }

  renderLoadMoreButton() {
    if (this.props.mode === ViewMode.LOADING_MORE) {
      return (
        <IonSpinner
          className="paginate-loading"
          icon="spiral"
        />
      );
    } else if (this.props.mode !== ViewMode.LOADING && this.props.hasMore) {
      return (
        <div
          className="paginate-label"
          onClick={this.props.onLoadMore}
        >
          {this.props.loadMoreLabel}
        </div>
      );
    } else {
      return null;
    }
  }
}

export const UserPinListComponent = I18nComponent(BaseUserPinListComponent, [
  ...UserPin.messages,
]);



// WEBPACK FOOTER //
// ./src/js/priorities/components/UserPinList/UserPinListComponent.js